// extracted by mini-css-extract-plugin
module.exports = {"permissionsWrapper":"style_permissionsWrapper__dVAJt","toolbar":"style_toolbar__FabIe"};